/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.38574 4.00003C9.74445 3.68265 10.0862 3.39957 10.3973 3.15333C10.8509 2.79425 11.0777 2.61471 11.4704 2.50693C11.756 2.42854 12.2433 2.42851 12.5289 2.50687C12.9216 2.61459 13.1479 2.7937 13.6005 3.15192C15.9354 4.99966 20 8.92397 20 13.8519C20 14.2491 19.9786 14.6318 19.9374 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2L6.76196 6.76196M22 22L18.644 18.644M6.76196 6.76196C5.2501 8.69456 4 11.1189 4 13.8518C4 22.7701 14.7817 24.3676 18.644 18.644M6.76196 6.76196L18.644 18.644"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M6.76196 6.76196C5.2501 8.69456 4 11.1189 4 13.8519C4 22.7701 14.7817 24.3676 18.644 18.644L6.76196 6.76196Z"
				fill="currentColor"
			/>
			<path
				d="M2 2L6.76196 6.76196M22 22L18.644 18.644M6.76196 6.76196C5.2501 8.69456 4 11.1189 4 13.8518C4 22.7701 14.7817 24.3676 18.644 18.644M6.76196 6.76196L18.644 18.644M9.38576 4.00003C9.74447 3.68265 10.0862 3.39957 10.3973 3.15333C10.8509 2.79425 11.0777 2.61471 11.4704 2.50693C11.756 2.42854 12.2433 2.42851 12.5289 2.50687C12.9216 2.61459 13.1479 2.7937 13.6006 3.15192C15.9354 4.99966 20 8.92397 20 13.8519C20 14.2491 19.9786 14.6318 19.9374 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L5.77087 6.83153C4.38044 8.75208 3.25 11.1432 3.25 13.8518C3.25 18.6816 6.20595 21.5902 9.69085 22.466C12.8471 23.2592 16.4933 22.3934 18.7205 19.7811L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L19.1743 18.1137L7.29229 6.23163L2.53033 1.46967ZM12.7273 1.78359C12.4971 1.72044 12.2313 1.69811 11.9996 1.69812C11.7679 1.69813 11.5021 1.7205 11.2719 1.78368C10.7304 1.93229 10.3941 2.19891 9.98055 2.52664L9.9318 2.56527C9.61105 2.81916 9.25871 3.11102 8.88878 3.43833C8.57856 3.7128 8.54958 4.18679 8.82406 4.49701C9.09853 4.80723 9.57252 4.83621 9.88274 4.56173C10.2302 4.25429 10.5614 3.97998 10.8628 3.74139C11.3337 3.36861 11.4462 3.29132 11.6689 3.23018C11.7243 3.21498 11.8449 3.19813 11.9997 3.19812C12.1544 3.19811 12.2751 3.21494 12.3305 3.23014C12.5533 3.29128 12.6654 3.36829 13.1351 3.74004C14.2714 4.63926 15.8133 6.03268 17.0659 7.78326C18.3196 9.53533 19.25 11.5975 19.25 13.8519C19.25 14.2222 19.2301 14.577 19.192 14.9166C19.146 15.3282 19.4423 15.6993 19.8539 15.7454C20.2656 15.7915 20.6367 15.4951 20.6827 15.0835C20.7272 14.6866 20.75 14.276 20.75 13.8519C20.75 11.1783 19.6481 8.81439 18.2858 6.9104C16.9224 5.00492 15.2646 3.51232 14.066 2.5638L14.0175 2.5254C13.6046 2.19826 13.2688 1.93214 12.7273 1.78359Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 2L6.76196 6.76196M22 22L18.644 18.644M6.76196 6.76196C5.2501 8.69456 4 11.1189 4 13.8518C4 22.7701 14.7817 24.3676 18.644 18.644M6.76196 6.76196L11.9998 11.9998M9.38576 4.00003C9.74447 3.68265 10.0862 3.39957 10.3973 3.15333C10.8509 2.79425 11.0777 2.61471 11.4704 2.50693C11.756 2.42854 12.2433 2.42851 12.5289 2.50687C12.9216 2.61459 13.1479 2.7937 13.6006 3.15192C15.9354 4.99966 20 8.92397 20 13.8519C20 14.2491 19.9786 14.6318 19.9374 15M18.644 18.644L15 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 2L6.76196 6.76196M22 22L18.644 18.644M6.76196 6.76196C5.2501 8.69456 4 11.1189 4 13.8518C4 22.7701 14.7817 24.3676 18.644 18.644M6.76196 6.76196L18.644 18.644M9.38576 4.00003C9.74447 3.68265 10.0862 3.39957 10.3973 3.15333C10.8509 2.79425 11.0777 2.61471 11.4704 2.50693C11.756 2.42854 12.2433 2.42851 12.5289 2.50687C12.9216 2.61459 13.1479 2.7937 13.6006 3.15192C15.9354 4.99966 20 8.92397 20 13.8519C20 14.2491 19.9786 14.6318 19.9374 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M6.69324 5.63232L6.17124 6.29959C4.60416 8.30278 3.25 10.8871 3.25 13.8516C3.25 18.6814 6.20594 21.59 9.69085 22.4658C13.1203 23.3276 17.1282 22.2309 19.2657 19.0633L19.6116 18.5507L6.69324 5.63232Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.46967 1.46967C1.76256 1.17678 2.23744 1.17678 2.53033 1.46967L7.29229 6.23163L19.1743 18.1137L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L18.1137 19.1743L6.23163 7.29229L1.46967 2.53033C1.17678 2.23744 1.17678 1.76256 1.46967 1.46967ZM11.9996 1.69812C12.2313 1.69811 12.4971 1.72044 12.7273 1.78359C13.2688 1.93214 13.6046 2.19826 14.0175 2.5254C14.0335 2.53811 14.0497 2.55091 14.066 2.5638C15.2646 3.51232 16.9224 5.00492 18.2858 6.9104C19.6481 8.81439 20.75 11.1783 20.75 13.8519C20.75 14.276 20.7272 14.6866 20.6827 15.0835C20.6367 15.4951 20.2656 15.7915 19.8539 15.7454C19.4423 15.6993 19.146 15.3282 19.192 14.9166C19.2301 14.577 19.25 14.2222 19.25 13.8519C19.25 11.5975 18.3196 9.53533 17.0659 7.78326C15.8133 6.03268 14.2714 4.63926 13.1351 3.74004C12.6654 3.36829 12.5533 3.29128 12.3305 3.23014C12.2751 3.21494 12.1544 3.19811 11.9997 3.19812C11.8449 3.19813 11.7243 3.21498 11.6689 3.23018C11.4462 3.29132 11.3337 3.36861 10.8628 3.74139C10.5614 3.97998 10.2302 4.25429 9.88274 4.56173C9.57252 4.83621 9.09853 4.80723 8.82406 4.49701C8.54958 4.18679 8.57856 3.7128 8.88878 3.43833C9.25871 3.11102 9.61105 2.81916 9.9318 2.56527C9.94818 2.5523 9.96443 2.53943 9.98055 2.52664C10.3941 2.19891 10.7304 1.93229 11.2719 1.78368C11.5021 1.7205 11.7679 1.69813 11.9996 1.69812Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
